import type { FC } from 'react';
import { PropsWithChildren } from 'react';
import s from './LayoutContainer.scss';

const LayoutContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <div className={s['root']}>{children}</div>;
};
LayoutContainer.displayName = 'LayoutContainer';

export default LayoutContainer;
